var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2LockerBis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.62 49.26L39 35.27v-2.39c0-.46 0-.55 1.2-1.27a6.63 6.63 0 003.8-6.3 7.05 7.05 0 00-14.1 0h4a3.05 3.05 0 116.1 0c0 1.75-.63 2.12-1.88 2.86C36.87 28.91 35 30 35 32.88v2.38l-25.62 14a2 2 0 00-.63 3 2.001 2.001 0 001.63.75h53.24a2 2 0 001.63-.75 2 2 0 00-.63-3zM18 49l19-10 19.12 10H18z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E2_Locker_bis.3f3a6f1e.svg";
export { SvgE2LockerBis as ReactComponent };